// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__Ozn1q","skeleton-animation":"styles_skeleton-animation__YDXFH"};